import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';

export default function reducer(state = {}, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response && action.response.data && !action.isManageAccounts) {
				return normalize(
					action.response.data.flatMap((account) => account.assertions).flatMap((assertion) => assertion.risks)
				);
			}
			return state;
		default:
			return state;
	}
}
